import Model, { attr, belongsTo } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

interface IAirbnbOfficialBookingCancellationReasonSchema {
  reason: string;
  sub_reasons: string[];
}

export default class AirbnbOfficialBookingModel extends Model {
  @attr('string') status!: string;
  @attr('string') reason!: string;
  @attr('string') subReason!: string | null;
  @attr('string') messageToGuest!: string;
  @attr('string') messageToAirbnb!: string;
  @attr('array')
  cancellationReasons!: IAirbnbOfficialBookingCancellationReasonSchema[];

  @belongsTo('booking', {
    inverse: 'airbnbOfficialBooking',
    async: false,
  })
  booking!: ModelRegistry['booking'];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'airbnb-official-booking': AirbnbOfficialBookingModel;
  }
}
